<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const props = defineProps({
	stream: {
		type: Object,
		required: true,
		validator(v) {
			return Object.prototype.hasOwnProperty.call(v, '_id');
		}
	},
	streamAlive: {
		type: Boolean
	},
	backupStreamAlive: {
		type: Boolean,
		default() { return false; }
	},
})

const childViewList = [
	{
		streamType: 'live',
		name: 'player interface',
		viewName: 'StreamsManageSettingsPlayerInterface'
	},
	{
		streamType: 'live',
		name: 'player functions',
		viewName: 'StreamsManageSettingsPlayerFunctions'
	},
	{
		streamType: 'live',
		name: 'security',
		viewName: 'LivestreamManageSecuritySettings'
	},
	{
		streamType: 'live',
		name: 'adaptive bitrate',
		viewName: 'StreamsManageSettingsAdaptiveBitrate'
	},
	{
		streamType: 'live',
		name: 'alerts',
		viewName: 'StreamsManageAlerts'
	},
	{
		streamType: 'vod',
		name: 'player settings',
		viewName: 'VODBucketPlayerSettings'
	},
	{
		streamType: 'vod',
		name: 'security',
		viewName: 'VODBucketSecuritySettings'
	}
]

const isActive = (name) => {
	// Match nested routes too (e.g. Alerts → Notifications/Webhooks) so the
	// sidebar item stays highlighted on child pages.
	return route.name === name || route.matched.some((r) => r.name === name)
}

const childViews = computed(() => {
	return (props.stream && childViewList.filter(v => {
		const isIncluded = v.streamType === props.stream.type
		return isIncluded && v.validate ? v.validate(props.stream) : isIncluded
	}))
})

const emit = defineEmits({
	'stream-updated': () => true,
	'set-live-stream-countdown': () => true,
	'live-stream-abr-changed': () => true
})
const onStreamUpdated = (updates) => {
	emit('stream-updated', updates)
}
const liveStreamCountdownSelected = (d) => {
	emit('set-live-stream-countdown', d);
}
const liveStreamAbrChanged = (d) => {
	emit('live-stream-abr-changed', d);
}
</script>
<template>
	<div class="flex flex-col md:flex-row md:gap-4 md:items-start">
		<nav class="flex md:flex-col gap-1 md:w-52 shrink-0 mb-4 md:mb-0 overflow-x-auto md:overflow-visible bg-surface-1 rounded-xl p-2">
			<router-link v-for="(viewItem, index) in childViews" :key="index" :to="{ name: viewItem.viewName }"
				class="capitalize text-sm font-medium text-surface-8 hover:text-white hover:no-underline hover:bg-surface-3 px-3 py-2 rounded-md text-nowrap transition-colors md:w-full"
				:class="{ '!bg-main-transparent !text-white': isActive(viewItem.viewName) }">
				{{ viewItem.name }}
			</router-link>
		</nav>
		<div class="flex-1 min-w-0 bg-surface-1 rounded-xl p-4 md:p-5">
			<router-view :stream="stream" :stream-alive="streamAlive" :backup-stream-alive="backupStreamAlive"
				@stream-updated="onStreamUpdated"
				@set-live-stream-countdown="liveStreamCountdownSelected" @live-stream-abr-changed="liveStreamAbrChanged" />
		</div>
	</div>
</template>

<style scoped></style>
